import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Form, Select } from 'antd';
import { ArrowDropDown } from '@material-ui/icons';
import { MparticleAudience } from 'core/mparticle/types';

const { Option } = Select;

type AudienceFieldsType = {
  audiences: MparticleAudience[];
  selectedAudience?: MparticleAudience;
  audienceId?: number;
  isLoading: boolean;
  onChange: (value: number) => void;
};

const AudienceFields: React.FC<AudienceFieldsType> = ({
  audiences,
  selectedAudience,
  audienceId,
  isLoading,
  onChange,
}) => {
  const intl = useIntl();

  return (
    <Form.Item>
      <p className="title_deals">
        <FormattedMessage id="mParticle audience" />
      </p>
      <Select
        className="select_modal"
        suffixIcon={<ArrowDropDown />}
        onChange={onChange}
        id="mparticle_audience_filter"
        value={selectedAudience ? audienceId : undefined}
        loading={isLoading}
        disabled={isLoading}
        placeholder={intl.formatMessage({ id: isLoading ? 'Loading audiences' : 'Select an audience' })}
        dropdownStyle={{ paddingLeft: '0', paddingRight: '0' }}
      >
        {audiences.map(audience => (
          <Option
            value={audience.id}
            key={audience.id}
            style={{ fontFamily: 'Lato', color: '#242c40' }}
            title={audience.name}
          >
            {audience.name}
          </Option>
        ))}
      </Select>
      {!isLoading && audienceId && !selectedAudience ? (
        <p className="audience_unusable_text">
          <FormattedMessage id="The saved audience is no longer available in mParticle" />
        </p>
      ) : (
        <></>
      )}
      {selectedAudience ? (
        <>
          <div className="audience-info">
            <div>{intl.formatMessage({ id: 'Audience size' })}</div>
            <div>{selectedAudience.size != null ? selectedAudience.size.toLocaleString() : '-'}</div>
            <div>{intl.formatMessage({ id: 'Audience ID' })}</div>
            <div>{selectedAudience.id}</div>
            <div>{intl.formatMessage({ id: 'Connected S3 output' })}</div>
            <div className={selectedAudience.usable ? '' : 'audience_unusable_value'}>
              {intl.formatMessage({ id: selectedAudience.usable ? 'Yes' : 'No' })}
            </div>
          </div>
          {!selectedAudience.usable && (
            <p className="audience_unusable_text">
              <FormattedMessage id="This audience cannot be used because it has no connected S3 output" />
            </p>
          )}
        </>
      ) : (
        <></>
      )}
    </Form.Item>
  );
};

AudienceFields.defaultProps = {
  selectedAudience: undefined,
  audienceId: undefined,
};

export default AudienceFields;
